import { useMemo } from "react";
import { useIntl } from "react-intl";

import { OVER_70, UNDER_5 } from "./formConstants";

export const useExemptionTypes = () => {
  const { formatMessage } = useIntl();

  const exemptions = useMemo(
    () => [
      {
        value: UNDER_5,
        label: formatMessage({
          id: "billing.exemption.under5.label",
          defaultMessage: "Under 5 years",
        }),
        "data-testid": "billing.exemption.under5",
      },
      {
        value: OVER_70,
        label: formatMessage({
          id: "billing.exemption.over70.label",
          defaultMessage: "Over 70",
        }),
        "data-testid": "billing.exemption.over70",
      },
    ],
    [formatMessage],
  );

  return exemptions;
};
